import {map} from 'rxjs/operators';

import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

import {DirectModuleSelectionService} from 'shared/services/direct-module-selection/direct-module-selection.service';

@Injectable({
  providedIn: 'root'
})
export class HomeGuard {
  private readonly redirectToAnalyzerIfDisallowed = this.service.isDirect$.pipe(
    map(isDirect => (isDirect ? this.router.parseUrl('analyzer') : true))
  );

  constructor(
    private readonly service: DirectModuleSelectionService,
    private readonly router: Router
  ) {}

  canActivate() {
    return this.redirectToAnalyzerIfDisallowed;
  }

  canActivateChild() {
    return this.redirectToAnalyzerIfDisallowed;
  }
}
